import { useNumberFormatter } from '../../../../../../../Components/NumberDisplay';
import { useBondsBondTransformApi } from '../api';
import { useGetDateFnsLocale } from '../../../../../../../Components/getDateLocale';
import { makeBondSlugTransformFn } from '../../../shared/makeBondSlug';

const intRateFormat = {
  format: {
    style: 'percent' as const,
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  },
  divider: 100,
};

export const useBondsBondSlug = (props?: {
  maxSIssuerName1Length?: number,
}) => {
  const {
    maxSIssuerName1Length,
  } = props ?? {};
  const intRateFormatter = useNumberFormatter(intRateFormat);
  const locale = useGetDateFnsLocale();
  const transformFn = makeBondSlugTransformFn({
    intRateFormatter,
    locale,
    maxSIssuerName1Length,
  });
  const response = useBondsBondTransformApi(transformFn);
  return response;
};
